import { StyleSheet } from 'react-native';
import { PALETTE } from '../../../constants';

export default StyleSheet.create({
  root: {
    flexDirection: 'row',
    justifyContent: 'center',
    margin: 10,
  },
  button: {
    flexDirection: 'row',
    backgroundColor: PALETTE.secondaryBackground,
    alignItems: 'center',
    borderRadius: 2,
    paddingHorizontal: 7,
    paddingVertical: 3,
  },
  buttonDisabled: {
    backgroundColor: '#222',
  },
  buttonNumber: {
    marginLeft: 5,
    paddingHorizontal: 8,
    justifyContent: 'center',
  },
  buttonPrev: {
    width: 60,
    width: 'max-content',
    justifyContent: 'center',
  },
  buttonNext: {
    marginLeft: 5,
    width: 'max-content',
    justifyContent: 'center',
  },
  buttonActive: {
    // backgroundColor: PALETTE.primaryActive,
  },
  textActive: {
    color: PALETTE.primaryActive,
    fontWeight: 'bold',
  },
  textDisabled: {
    color: '#333',
  },
  textNext: {
    marginRight: 5,
  },
  textPrev: {
    marginLeft: 5,
  },
  pageMore: {
    marginLeft: 5,
  },
});
